import {
  MEDICINE_SEARCH, MEDICINE_SEARCH_SUCCESS, MEDICINE_SEARCH_FAILURE, MEDICINE_CLEAR,
  MEDICINE_TYPE_SEARCH, MEDICINE_TYPE_SEARCH_SUCCESS, MEDICINE_TYPE_SEARCH_FAILURE,
  MEDICINE_DETAIL, MEDICINE_DETAIL_SUCCESS, MEDICINE_DETAIL_FAILURE, MEDICINE_DETAIL_CLEAR,
  MEDICINE_UPDATE_COMMENT, MEDICINE_UPDATE_COMMENT_SUCCESS, MEDICINE_UPDATE_COMMENT_FAILURE,
  MEDICINE_CSV_IMPORT_START, MEDICINE_CSV_IMPORT, MEDICINE_CSV_IMPORT_FAILURE, MEDICINE_CSV_IMPORT_SUCCESS,
  MEDICINE_CSV_MASTER_IMPORT_START, MEDICINE_CSV_MASTER_IMPORT, MEDICINE_CSV_MASTER_IMPORT_FAILURE, MEDICINE_CSV_MASTER_IMPORT_SUCCESS
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    medicine: null,
    medicines: null,
    medicineTypes: null,
    medicinesNextPage: null,
    medicinesTotalCount: 0,
    medicinesCurrentPage: null,
    searchParams: null,
    importer: {
      count: 0,
      logs: ''
    },
    sideEffects: null,
    medicinesNotify: null
  },
  getters: {
    medicine: state => {
      return state.medicine
    },
    medicines: state => {
      return state.medicines
    },
    medicineTypeList: state => {
      return state.medicineTypes
    },
    medicinesNextPage: state => {
      return state.medicinesNextPage
    },
    medicinesTotalCount: state => {
      return state.medicinesTotalCount
    },
    medicinesSearchParams: state => {
      return state.searchParams
    },
    medicineImportMessage: state => {
      if (state.importer.count === 0) {
        return ''
      } else {
        return 'medicines.import_sucess_message'
      }
    },
    medicineImportLogs: state => {
      return state.importer.logs
    },
    sideEffects: state => {
      return state.sideEffects
    },
    medicinesCurrentPage: state => {
      return state.medicinesCurrentPage
    },
    /** 通知 */
    medicinesNotify: state => {
      return state.medicinesNotify
    }
  },
  actions: {
    [MEDICINE_SEARCH] ({dispatch, state, commit}, params = null) {
      var url = '/medicines'
      var data = {}
      var loadparams = 'true'
      var callback = () => {}

      if (params) {
        if (params.url) {
          url = params.url
        }
        if (params.clear) {
          state.medicines = null
          state.medicinesNextPage = null
          state.medicinesTotalCount = 0
          state.medicinesCurrentPage = null
        }
        if (params.loadparams) {
          loadparams = params.loadparams
        }
        if ('callback' in params) {
          callback = params.callback
        }
        state.searchParams = params.data
        data = params.data
      }
      dispatch('apiGet', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_SEARCH_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MEDICINE_SEARCH_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_TYPE_SEARCH] ({dispatch, state, commit}) {
      var url = '/medicines/type_search'
      dispatch('apiGet', {url: url})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_TYPE_SEARCH_FAILURE, {data: res.data})
          } else {
            commit(MEDICINE_TYPE_SEARCH_SUCCESS, {data: res.data})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(MEDICINE_CLEAR)
      }, sleep)
    },
    [MEDICINE_DETAIL] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_DETAIL:' + params.medicineId)
      var url = '/medicines/' + params.medicineId
      var callback = () => {}
      if (params) {
        if ('callback' in params) {
          callback = params.callback
        }
      }

      dispatch('apiGet', {url: url})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_DETAIL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(MEDICINE_DETAIL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_DETAIL_CLEAR] ({state, commit}, sleep = 0) {
      setTimeout(() => {
        commit(MEDICINE_DETAIL_CLEAR)
      }, sleep)
    },
    [MEDICINE_UPDATE_COMMENT] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_UPDATE_COMMENT')
      var url = '/medicines/' + params.medicineId
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: url, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_UPDATE_COMMENT_FAILURE, res.data)
          } else {
            commit(MEDICINE_UPDATE_COMMENT_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_CSV_IMPORT_START] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_CSV_IMPORT_START')
      state.importer.count = 0
      state.importer.logs = ''
    },
    [MEDICINE_CSV_MASTER_IMPORT_START] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_CSV_MASTER_IMPORT_START')
      state.importer.count = 0
      state.importer.logs = ''
    },
    [MEDICINE_CSV_IMPORT] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_CSV_IMPORT')
      var url = '/medicines'

      dispatch('apiPost', {url: url, data: params.data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_CSV_IMPORT_FAILURE, res.data)
          } else {
            commit(MEDICINE_CSV_IMPORT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [MEDICINE_CSV_MASTER_IMPORT] ({dispatch, state, commit}, params = null) {
      console.log('MEDICINE_CSV_MASTER_IMPORT')
      var url = '/medicines/medicines_master_csv_import'

      dispatch('apiPost', {url: url, data: params.data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(MEDICINE_CSV_MASTER_IMPORT_FAILURE, res.data)
          } else {
            commit(MEDICINE_CSV_MASTER_IMPORT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [MEDICINE_SEARCH_FAILURE] (state, data) {
      console.log('MEDICINE_SEARCH_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [MEDICINE_SEARCH_SUCCESS] (state, params) {
      console.log('MEDICINE_SEARCH_SUCCESS')
      var data = params.data
      var reSearch = false

      if (data.meta && data.meta['re-search']) {
        reSearch = data.meta['re-search']
      }

      if (reSearch) {
        // 再検索
        state.medicines = data.data
        if (data.meta['next-page'] === null) {
          // 次へのリンクが無かったら
          state.medicinesNextPage = null
        }
      } else {
        if (data.meta && data.meta['current-page'] && data.meta['current-page'] > 1) {
          state.medicines = state.medicines.concat(data.data)
          state.medicinesCurrentPage = data.meta['current-page']
        } else {
          state.medicines = data.data
          state.medicinesCurrentPage = 1
        }
        if (data.links && data.links['next']) {
          state.medicinesNextPage = data.links['next']
        } else {
          state.medicinesNextPage = null
        }
      }

      // 検索件数
      state.medicinesTotalCount = 0
      if (data.meta && data.meta['total-count']) {
        state.medicinesTotalCount = data.meta['total-count']
      }

      if (params.callback) {
        params.callback()
      }
    },
    [MEDICINE_TYPE_SEARCH_FAILURE] (state, data) {
      console.log('MEDICINE_TYPE_SEARCH_FAILURE')
    },
    [MEDICINE_TYPE_SEARCH_SUCCESS] (state, data) {
      console.log('MEDICINE_TYPE_SEARCH_SUCCESS')
      state.medicineTypes = data.data
    },
    [MEDICINE_CLEAR] (state) {
      state.medicines = null
    },
    [MEDICINE_DETAIL_FAILURE] (state, data) {
      console.log('MEDICINE_DETAIL_FAILURE')
      if (data.callback) {
        data.callback()
      }
    },
    [MEDICINE_DETAIL_SUCCESS] (state, params) {
      console.log('MEDICINE_DETAIL_SUCCESS')
      var data = params.data
      state.medicine = data.medicine.data

      if (data.side_effects) {
        state.sideEffects = data.side_effects.data
      }
      if (params.callback) {
        params.callback(state.medicine)
      }
    },
    [MEDICINE_DETAIL_CLEAR] (state) {
      state.medicine = null
      state.sideEffects = null
    },
    [MEDICINE_UPDATE_COMMENT_FAILURE] (state, data) {
      console.log('MEDICINE_UPDATE_COMMENT_FAILURE')
      // 通知
      state.medicinesNotify = {
        danger: true,
        message_i18n: 'messages.save.danger'
      }
      setTimeout(() => {
        state.medicinesNotify = null
      }, constant.notifyShowTime.normal)
    },
    [MEDICINE_UPDATE_COMMENT_SUCCESS] (state, data) {
      console.log('MEDICINE_UPDATE_COMMENT_SUCCESS')
      // 通知
      state.medicinesNotify = {
        success: true,
        message_i18n: 'messages.save.success'
      }
      setTimeout(() => {
        state.medicinesNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [MEDICINE_CSV_IMPORT_FAILURE] (state, data) {
      console.log('MEDICINE_CSV_IMPORT_FAILURE')
      state.importer.logs = data.logs
    },
    [MEDICINE_CSV_IMPORT_SUCCESS] (state, data) {
      console.log('MEDICINE_CSV_IMPORT_SUCCESS')
      state.importer.logs = data.logs
      state.importer.count = data.count
    },
    [MEDICINE_CSV_MASTER_IMPORT_FAILURE] (state, data) {
      console.log('MEDICINE_CSV_MASTER_IMPORT_FAILURE')
      state.importer.logs = data.logs
    },
    [MEDICINE_CSV_MASTER_IMPORT_SUCCESS] (state, data) {
      console.log('MEDICINE_CSV_MASTER_IMPORT_SUCCESS')
      state.importer.logs = data.logs
      state.importer.count = data.count
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/medicine.js